import React from 'react'
import ChangeBlock from './ChangeBlock'

const Changes = ({ changes }) => {

  return (
    <div className='changesBlock'>
        {/* <p>Таблиця змін по обʼєкту</p> */}
		{
			changes && changes.length > 0 ?
				changes.map((change) => {
					return (
						<ChangeBlock 
							key={change.id}
							change={change}
						/>
					)
				})
			: 
				<div>
					Змін по обʼєкту не знайдено
				</div>
		}
    </div>
  )
}

export default Changes